import PropTypes from 'prop-types';
import * as React from 'react';
import { Controller } from 'react-hook-form';
import { TYPE_INPUT_DATE } from 'utils/constants';

export default function FormRangeCard({
  titleCard,
  dataValue,
  nameLabel,
  inputType,
  control,
  name
}) {
  const handleChangeInput = (inputValue, onChange) => {
    var pattern = /^-?(0|[1-9]\d*)(\.\d+)?$/;
    if (inputType === TYPE_INPUT_DATE) {
      onChange(inputValue);
    } else if (pattern.test(inputValue)) {
      onChange(parseInt(inputValue));
    } else if (
      (inputValue.length === 1 && inputValue === '-') ||
      inputValue.length === 0
    ) {
      onChange(inputValue);
    }
  };
  return (
    <>
      <div className=" p-4  border rounded-lg shadow-sm">
        <div className="border-b border-black pb-2">
          <p>{titleCard}</p>
        </div>

        <div className="my-4">
          <label className=" text-gray-700 font-semibold mb-2">
            {nameLabel?.start}
          </label>
          {!dataValue ? (
            <div className="animate-pulse space-y-2">
              <div className="h-[25px] bg-gray-300  rounded-md px-3 py-1 my-1"></div>
            </div>
          ) : (
            <Controller
              control={control}
              defaultValue={dataValue?.start}
              render={({ field: { onBlur, value, onChange } }) => (
                <input
                  type={inputType}
                  placeholder="Start"
                  onBlur={onBlur}
                  onChange={(e) => handleChangeInput(e.target.value, onChange)}
                  value={value}
                  className="mt-2 border border-gray-400 px-2 py-1 w-full rounded-lg focus:outline-none"
                />
              )}
              name={name?.start}
            />
          )}
        </div>
        <div className="my-4">
          <label className=" text-gray-700 font-semibold mb-2">
            {nameLabel?.end}
          </label>
          {!dataValue ? (
            <div className="animate-pulse space-y-2">
              <div className="h-[25px] bg-gray-300  rounded-md px-3 py-1 my-1"></div>
            </div>
          ) : (
            <Controller
              control={control}
              defaultValue={dataValue?.end}
              render={({ field: { onBlur, value, onChange } }) => (
                <input
                  placeholder="end"
                  type={inputType}
                  onBlur={onBlur}
                  onChange={(e) => handleChangeInput(e.target.value, onChange)}
                  value={value}
                  className="mt-2 border border-gray-400 px-2 py-1 w-full rounded-lg focus:outline-none focus:border-blue-400"
                />
              )}
              name={name?.end}
            />
          )}
        </div>
      </div>
    </>
  );
}

FormRangeCard.propTypes = {
  titleCard: PropTypes.string,
  dataValue: PropTypes.object,
  nameLabel: PropTypes.object,
  inputType: PropTypes.string,
  control: PropTypes.object,
  name: PropTypes.object
};
